import { TileCalculateData } from "../components/EditorContext";
import { TileData } from "../EditorNew";

export function getTopmostTile(tiles: TileData[][]) {
  const rowLength = tiles[0]?.length || tiles[1]?.length;
  let topMostTile: TileCalculateData = null!;
  for (let i = 0; i < tiles?.length - 2; i++) {
    for (let j = 0; j < rowLength - 1; j++) {
      if (!tiles[i][j]?.inactive && tiles[i][j]?.transform?.color && !topMostTile) {
        topMostTile = { tile: tiles[i][j], y: i + 1, x: j + 1 };
        break;
      }
      if (topMostTile) {
        break;
      }
    }
  }

  let min = Number.MAX_VALUE;
  let tile: TileData = null!;
  tiles[tiles?.length - 1]?.forEach(value => {
    if (value.position.posY < min) {
      tile = value;
      min = value.position.posY;
    }
  });

  let child: TileData = null!;
  let parent: TileCalculateData = null!;
  if (tile?.position.posY < topMostTile?.tile?.position?.posY) {
    child = tile;
    for (let i = 0; i < tiles?.length - 2; i++) {
      for (let j = 0; j < rowLength - 1; j++) {
        if (tiles[i][j]?.id === child?.parentId && !parent) {
          parent = { tile: tiles[i][j], y: i + 1, x: j + 1 };
          break;
        }
        if (parent) {
          break;
        }
      }
    }
  }

  if (parent) {
    return { ...parent, child };
  } else {
    return { ...topMostTile, child };
  }
}
